// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-f29b5350]{text-decoration:none}.status-label[data-v-f29b5350],.no-sales-channels-label[data-v-f29b5350]{width:240px}.status-label-circle[data-v-f29b5350]:before{content:\"●\";font-size:16px;padding-right:8px}.service-level[data-v-f29b5350]{pointer-events:none}.service-level-text[data-v-f29b5350]{min-width:144px;text-align:center}.retailer[data-v-f29b5350]{display:inline-block;min-width:110px}", ""]);
// Exports
module.exports = exports;
